import React, { useState } from 'react';
import './VideoModal.css';

const VideoModal = ({ videoSrc, thumbnailSrc }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = (e) => {
    e.preventDefault();
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <>
      <div className="works-image">
        <img src={thumbnailSrc} alt="Works" />
        <a href="#" onClick={openModal} className="video-btn">
          <i className="flaticon-play-button"></i>
        </a>
      </div>

      {isOpen && (
        <div className="video-modal-overlay" onClick={closeModal}>
          <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="video-modal-close" onClick={closeModal}>
              <i className="fas fa-times"></i>
            </button>
            <video controls autoPlay className="video-player">
              <source src={videoSrc} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      )}
    </>
  );
};

export default VideoModal;
